import React from 'react'
import { FormattedMessage } from 'react-intl'
import 'normalize.css'
import styled from 'styled-components'
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor'
import { NavHashLink as NavLink } from 'react-router-hash-link'
import CookieBanner from 'react-cookie-banner'

import manoMovil from './assets/img/mano-movil.png'

import Header from './components/Header'
import Footer from './components/Footer'
//sections
import Info from './components/home/Info'
import Ventajas from './components/home/Ventajas'
import Funcionamiento from './components/home/Funcionamiento'
import Services from './components/home/Services'
import Faq from './components/home/Faq'
import Distribuidor from './components/home/Distribuidor'

class App extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <main className="main">
                <Header />
                <section className="intro" id="start">
                    <div className="container">
                        <div className="intro__col1">
                            <div>
                                <h1 className="intro__title">
                                    <FormattedMessage id="apertura" defaultMessage="Apertura" /> <FormattedMessage id="sin_llaves" defaultMessage="sin llaves" />
                                </h1>

                                <p className="intro__text">
                                    <FormattedMessage
                                        id="Gestiona_la_apertura_de_tus_apartamentos_oficinas_o_centros_de_negocios_cómodamente_desde_tu_móvil_Apertura_sin_llaves_de_puerta_principal_portal_garaje_y_demás_dependencias"
                                        defaultMessage="Gestiona la apertura de tus apartamentos, oficinas o centros de negocios cómodamente desde tu móvil. Apertura sin llaves de puerta principal, portal, garaje y demás dependencias."
                                    />
                                </p>
                            </div>
                        </div>
                        <div className="intro__col2">
                            <div>
                                <img className="intro__img" src={manoMovil} alt="hand" />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section__info" id="section__info">
                    <Info />
                </section>

                <section className="section__ventajas" id="section__ventajas">
                    <Ventajas />
                </section>
                <section className="section__funcionamiento" id="section__funcionamiento">
                    <Funcionamiento />
                </section>
                <section className="section__services" id="section__services">
                    <Services />
                </section>
                <section className="section__faq" id="section__faq">
                    <Faq />
                </section>
                <section className="section__distribuidor" id="section__distribuidor">
                    <Distribuidor />
                </section>

                <Footer />
                <CookieBanner
                    styles={{
                        banner: {
                            position: 'fixed',
                            textAlign: 'center',
                            bottom: 0,
                            padding: '1em',
                            height: 'auto',
                            backgroundColor: 'rgba(60, 60, 60, 0.8)',
                            width: 'calc(100% - 30px)'
                        },
                        button: {
                            margin: '10px auto',
                            position: 'relative',
                            width: '100%',
                            maxWidth: '320px',
                            backgroundColor: '#65cbc9',
                            padding: '0.5rem 3rem',
                            color: '#fff',
                            display: 'block',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            right: 0
                        },
                        message: { fontWeight: 400, lineHeight: '0' }
                    }}
                    message="Seyte utiliza cookies propias y de terceros para mejorar nuestros servicios. Si continúas navegando, consideramos que aceptas su uso."
                    link={{
                        msg: 'Para más información visita nuestra política de Cookies',
                        url: '/politica-de-cookies'
                    }}
                    buttonMessage="Aceptar"
                    dismissOnScroll={false}
                />
            </main>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js